export default [
    {
        "Name": "Adam Chan",
        "Location": "荃灣",
        "Comments": "我每日都揸車番工，屋企車位都會空置起碼9粒鐘，依家利用呢個空置時間放租，賺取額外收入! 推!",
    },
    {
        "Name": "Karen Leung",
        "Location": "九龍灣",
        "Comments": "揸車去開會，次次都好難搵到車位，下下被迫泊街邊，用呢個停車app，省時省錢又安全。",
    },
    {
        "Name": "Jack So",
        "Location": "Mong Kok",
        "Comments": "Safe parking and effective tools, for sure will use again and the service is professional with the customer service support.",
    }
];
